import NavHeader from './nav-header.vue'
export default NavHeader



// WEBPACK FOOTER //
// ./src/common-components/nav-header/index.js